<template>
	<div class="content_retix enedis-consent-management-view">
	<div class="container-retix">
		<!-- en-tête au style de « Mes études » (13/10/2026) -->
		<div class="enedis-consent-management-header">
			<div>
				<h1 class="page-titre">Consentements Enedis</h1>
				<p class="page-sous-titre">Demandes d'accès aux données des compteurs Linky (Enedis Data Connect)</p>
			</div>
			<router-link :to="{name:'enedis-consent-new'}" class="btn-jaune">+ Nouvelle demande</router-link>
		</div><!--  class="enedis-consent-management-header" -->
		<div class="bloc_content mt-5">
			<!-- Filtres et recherche au-dessus du tableau (12/10/2026) ; utilisateur : seulement si la liste en compte plusieurs -->
			<div class="liste-outils">
				<filtre-bouton v-if="auteurs.length > 1" v-model="filtreAuteur" nom="auteur" libelle="Utilisateur"
					tous="Tous les utilisateurs" :options="auteurs.map(a => ({ value: a, label: a }))" />
				<filtre-bouton v-model="filtreEtat" nom="etat" libelle="État" tous="Tous les états"
					:options="etats.map(e => ({ value: e.code, label: e.text }))" />
				<span class="consent-count">{{ consentsAffiches.length }} demande{{ consentsAffiches.length > 1 ? 's' : '' }}</span>
				<input v-model="searchText" type="search" class="liste-recherche" placeholder="Rechercher (description, e-mail, code…)"
					aria-label="Rechercher une demande" />
			</div>
			<div class="consent-defilement">
			<table class="consent-list">
		  		<thead>
		  			<tr>
						<th><button class="sort-btn" @click="trier('etat')">État <span class="sort-icon">{{ icone('etat') }}</span></button></th>
		  				<th><button class="sort-btn" @click="trier('code')">Code <span class="sort-icon">{{ icone('code') }}</span></button></th>
		  				<th><button class="sort-btn" @click="trier('date')">Date <span class="sort-icon">{{ icone('date') }}</span></button></th>
		  				<th><button class="sort-btn" @click="trier('auteur')">Auteur <span class="sort-icon">{{ icone('auteur') }}</span></button></th>
						<th class="consent-retour">Valable jusqu'au</th>
						<th class="consent-description">Description</th>
		  				<th class="consent-menu"></th>
		  			</tr>
		  		</thead>
		  	      <tr class="consent-item"
				  	v-for="consent in consentsAffiches"
				  	:key="consent.id"
					:data-user-email="consent.email">
					<td class="consent-field" >
					<b-tooltip
						v-if="consent.statusData.textLong"
						:target="consent.badgeTooltipId"
						triggers="hover"
						>
						{{consent.statusData.textLong}}
					</b-tooltip>
					<span :id="consent.badgeTooltipId" class="enedis-consent-status-badge" :class="{ 'badge-hachure': consent.statusData.hachure }"
						:data-etat="consent.etat" :style="{'--badge-color':consent.statusData.color}">{{consent.statusData.text}}</span></td>
		  			<td class="consent-field" >{{consent.code}}</td>
					<td class="consent-field consent-date" ><span v-for="(morceau, i) in formatDate(consent.creationDatetime).split(' ')" :key="i" class="consent-date-morceau">{{ morceau }}</span></td>
					<td class="consent-field consent-retour" >{{consent.auteur}}</td>
					<td class="consent-field" :class="{ 'consent-expire': consent.expire }">{{ consent.expiration ? formatJour(consent.expiration) : '—' }}</td>
					<td class="consent-field consent-description" ><span class="consent-description-texte" :title="consent.description">{{consent.description}}</span></td>
		  			<td class="consent-menu">
						<template v-if="confirmDeleteId === consent.id">
							<span class="confirm-text">Supprimer cette demande ?</span>
							<button class="btn btn-danger btn-sm" @click="supprimer(consent)">Oui, supprimer</button>
							<button class="btn btn-secondary btn-sm" @click="confirmDeleteId = null">Annuler</button>
						</template>
						<div v-else class="consent-actions">
							<router-link
							:to="{name:'enedis-consent-detail',query:{id:consent.id,code:consent.code}}"
							class="btn-ligne" >Détails</router-link>
							<button class="btn-ligne btn-ligne--danger" title="Supprimer la demande" @click="confirmDeleteId = consent.id">Supprimer</button>
						</div>
					</td>
		  		  </tr><!-- class="consent-item" -->
				  <tr v-if="consentList.length && !consentsAffiches.length"><td colspan="7" class="consent-empty">Aucune demande ne correspond aux filtres.</td></tr>
		  	  </table><!-- class="consent-list" -->
			</div><!-- class="consent-defilement" -->
			  <p v-if="erreur" class="consent-error">{{ erreur }}</p>
		</div><!-- class="bloc_content" -->
	</div><!-- class="container-retix" -->
	</div><!-- class="content_retix enedis-consent-management-view" -->
</template>
<!-- Non scopé : b-tooltip est rendu hors du composant (portail vers <body>),
     les styles scopés ne l'atteignent pas. CSS plat obligatoire — pas de
     règles imbriquées, ce bloc n'est pas compilé par un préprocesseur. -->
<style>
.tooltip.consent-search-field-tooltip .tooltip-inner {
	min-width: 400px;
	max-width: 400px;
	text-align: left;
}

.tooltip.consent-search-field-tooltip .tooltip-inner p { margin-bottom: 5px; }
.tooltip.consent-search-field-tooltip .tooltip-inner p:last-child { margin-bottom: 0; }
.liste-outils { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 14px; }
.liste-recherche { margin-left: auto; padding: 8px 16px; border: 1px solid #ddd; border-radius: 20px; font-size: 13px; width: 280px; max-width: 100%; outline: none; }
.liste-recherche:focus { border-color: #f5c518; }
</style>
<style scoped>
.enedis-consent-management-header {
	display:flex;
	flex-direction:row;
	align-items:center;
	justify-content:space-between;
	flex-wrap:wrap;
	gap:12px;
	padding:28px 0 4px;
}
.page-titre { font-size:26px; font-weight:800; color:#1a1a2e; margin:0; }
.page-sous-titre { margin:4px 0 0; font-size:14px; color:#888; }
.btn-jaune { display:inline-block; padding:10px 22px; border-radius:22px; background:#f5c518; color:#1a1a2e; font-weight:700; font-size:14px; text-decoration:none; }
.btn-jaune:hover { background:#e6b800; color:#1a1a2e; text-decoration:none; }
.btn-ligne { display:inline-block; padding:4px 12px; border:1px solid #d5d9e0; border-radius:14px; background:#fff; color:#3a3f4b; font-size:13px; font-weight:600; text-decoration:none; cursor:pointer; margin-left:6px; }
.btn-ligne:hover { border-color:#f5c518; color:#1a1a2e; text-decoration:none; }
.btn-ligne--danger { color:#c62828; }
.btn-ligne--danger:hover { border-color:#c62828; color:#c62828; }
.consent-expire { color:#c62828; font-weight:600; }







.btn {
	border-radius:10px;
}


.consent-filters { display:flex; gap:20px; align-items:flex-end; margin-bottom:12px; flex-wrap:wrap; }
.consent-filters label { display:flex; flex-direction:column; gap:4px; margin:0; font-weight:600; }
.consent-filter { min-width:180px; padding:4px 8px; }
.consent-count { color:#666; margin-left:auto; }
.sort-btn { background:none; border:0; padding:0; font-weight:inherit; cursor:pointer; }
.sort-icon { color:#999; }
.consent-menu .btn { margin-left:6px; }
.confirm-text { margin-right:6px; }
.consent-empty { color:#666; font-style:italic; text-align:center; }
.consent-error { color:#c62828; margin-top:10px; }
/* écran étroit : le tableau défile dans son cadre au lieu d'en sortir */
.consent-defilement { overflow-x:auto; }

table.consent-list {
	
	th, td { padding:10px; }
	
	tr.consent-item:hover { background-color:var(--bleu-clair); }
	
	/* une seule ligne par cellule, sauf la description, qui prend la place restante et passe à la ligne (16/10/2026 :
	   une description longue poussait « Courbe » et les boutons hors du cadre) */
	width: 100%;
	td, th { white-space: nowrap; }
	.consent-description { white-space: normal; width: 100%; min-width: 140px; overflow-wrap: anywhere; }
	.consent-description-texte { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
	.consent-retour { white-space: normal; }
	.consent-date-morceau { display: block; }
	.consent-actions { display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
	.consent-actions .btn-ligne { margin-left: 0; }
	
	.consent-menu {
		text-align:right;
	}
}


</style>
<script>
import {authenticationService} from '../services/authentication';
import {enedisConsentService} from '../services/enedisConsent';
import utils  from '../utils/util.ts'
import FiltreBouton from '../components/FiltreBouton.vue'
import { ETATS, finDeValidite, etatDuConsentement, etatConsentement } from '../utils/etatConsentement'

export default {
	components: { FiltreBouton },

	props:	{
	},//props:	{
	
	data(){
		return {
			searchText:"",
			consentList:[],
			// filtres et tri (demande du 08/10/2026) ; auteur : seulement si la liste en compte plusieurs (admin)
			filtreEtat:"",
			filtreAuteur:"",
			triChamp:"date",
			triSens:"desc",
			confirmDeleteId:null,
			erreur:""
		};
	},//data(){
	
	computed: {
		etats() {
			return ETATS.map(code => ({ code, text: etatConsentement(code).text }))
		},
		auteurs() {
			return [...new Set(this.consentList.map(c => c.auteur))].sort((a, b) => a.localeCompare(b, 'fr'))
		},
		consentsAffiches() {
			const sens = this.triSens === 'asc' ? 1 : -1
			const cle = (c) => this.triChamp === 'date' ? c.creationDatetime.getTime()
				: this.triChamp === 'etat' ? ETATS.indexOf(c.etat)
				: this.triChamp === 'code' ? (c.code || '') : (c.auteur || '').toLowerCase()
			return this.consentList
				.filter(c => !this.filtreEtat || c.etat === this.filtreEtat)
				.filter(c => !this.filtreAuteur || c.auteur === this.filtreAuteur)
				.filter(c => this.correspond(c))
				.slice().sort((a, b) => {
					const x = cle(a), y = cle(b)
					return (x < y ? -1 : x > y ? 1 : 0) * sens
				})
		},
	},

	mounted() {
		this.searchDemands()
	},// mounted() {
	
	
	
	methods : {
		formatJour(d) {
			return d.toLocaleDateString('fr-FR')
		},
		// recherche dans la liste chargée (12/10/2026) : description, e-mail, code, message, auteur ; sans accents ni majuscules
		correspond(c) {
			const norme = t => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
			const mots = norme(this.searchText).split(/\s+/).filter(Boolean)
			if (!mots.length) return true
			const texte = norme([c.description, c.email, c.code, c.informationMessage, c.auteur].join(' '))
			return mots.every(m => texte.includes(m))
		},
		searchDemands(){
			let searchPromise = enedisConsentService.search({text:""})
			
			let receivedMgr = this.searchDemandsReceived.bind(this)
			let errorMgr = this.searchDemandsError.bind(this)
			searchPromise.then(receivedMgr).catch(errorMgr)
			
		},//searchDemands(){
		
		searchDemandsReceived(response){
			let data = [...response.data]
			for(let consent of data){
				consent.uuid = self.crypto.randomUUID();
				consent.badgeTooltipId = 'enedis-consent-badge-tooltip-'+consent.uuid
				consent.creationDatetime = new Date(consent.creationDatetime)
				// accord reçu mais dépassé (13/10/2026) : « Consentement expiré », date de fin affichée
				consent.expiration = finDeValidite(consent)
				consent.expire = consent.status === 'AUTHORIZED' && !!consent.expiration && consent.expiration < new Date()
				// un seul état : démarche du client puis récupération de la courbe (16/10/2026)
				consent.etat = etatDuConsentement(consent)
				consent.statusData = etatConsentement(consent.etat, consent)
				consent.auteur = this.formatUser(consent.creationUser)
			}
			this.consentList = data
		},//searchDemandsReceived(){
			
		searchDemandsError(error){
			console.log("views/EnedisConsentList.vue:searchDemandsError()",error)
		},//searchDemandsError(){
		
		trier(champ){
			if (this.triChamp === champ) this.triSens = this.triSens === 'asc' ? 'desc' : 'asc'
			else { this.triChamp = champ; this.triSens = champ === 'date' ? 'desc' : 'asc' }
		},
		icone(champ){
			return this.triChamp === champ ? (this.triSens === 'asc' ? '↑' : '↓') : '↕'
		},
		supprimer(consent){
			this.erreur = ""
			enedisConsentService.remove(consent.id).then(response => {
				// refus du serveur : statusCode dans le corps (comme pour les études, B24) — la ligne reste affichée
				if (response && response.statusCode && response.statusCode !== 200) {
					this.erreur = "Suppression refusée : " + (response.message || "demande introuvable")
					return
				}
				this.consentList = this.consentList.filter(c => c.id !== consent.id)
				this.confirmDeleteId = null
			}).catch(e => {
				this.erreur = "Suppression impossible : " + utils.getErrorMessage(e)
			})
		},

		formatDate(date){
			return date.toLocaleString().substr(0,16)
		},//formatDate(date){
		
		formatUser(user){
			if(!user) return ''
			if(utils.stringIsBlank(user.firstname) && utils.stringIsBlank(user.lastname))
				return user.email
			
			return user.firstname+" "+user.lastname
		},//formatUser(user){
	}//methods : {
}
</script>